<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        Generate Next Term Sessions
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="form.term_type"
              :items="termTypes"
              label="Term Type*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">Generate</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { rules } from "@/helpers/rules";

export default {
  data() {
    return {
      rules,
      form: {
        term_type: null,
      },
      termTypes: ["Semester", "Annual"],
    };
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.$emit("generate", { ...this.form });
    },
  },
};
</script>
